// extracted by mini-css-extract-plugin
export default {"container":"Projects_container__938tu","loadMargin":"Projects_loadMargin__x69x-"};